import { z } from 'zod';

export const TokenRequestSchema = z.object({
  provider: z.string(),
  authorizationCode: z.string(),
  fangroupId: z.string(),
  state: z.string().optional(),
  originUrl: z.string().optional(),
  isEmbedded: z.boolean().optional(),
  // FGO Insights T3 capture: deep-link origin (fan-group/brand slug) and wlId
  // (target wish-list id) query params -- see
  // docs/planned/fgo-insights/tasks/03-reach-entry-source-capture.md
  origin: z.string().optional(),
  wlId: z.string().optional(),
});

export type TokenRequest = z.infer<typeof TokenRequestSchema>;


